export default __webpack_public_path__ + "static/media/LoginPageImage.3245b041.png";